export default "__VITE_ASSET__56c995c4__"